import type { PluginExports } from 'graylog-web-plugin/plugin';

import type { TeamsPlugin } from 'components/roles/types';

import TeamsOverviewPage from './pages/TeamsOverviewPage';
import TeamDetailsPage from './pages/TeamDetailsPage';
import TeamEditPage from './pages/TeamEditPage';
import TeamCreatePage from './pages/TeamCreatePage';
import UserTeamsAssignment from './components/user/UserTeamsAssignment';
import RoleTeamsAssignment from './components/roles/RoleTeamsAssignment';
import useTeamMembersByRole from './logic/useTeamMembersByRole';

const teams: TeamsPlugin = {
  useTeamMembersByRole,
  UserTeamsAssignment,
  RoleTeamsAssignment,
};
const bindings: PluginExports = {
  teams,
  routes: [
    { path: '/system/teams', component: TeamsOverviewPage, permissions: 'team:read' },
    { path: '/system/teams/new', component: TeamCreatePage, permissions: 'team:create' },
    { path: '/system/teams/:teamId', component: TeamDetailsPage, permissions: 'team:read' },
    { path: '/system/teams/:teamId/edit', component: TeamEditPage, permissions: 'team:read' },
  ],
};
export default bindings;
